import { render, staticRenderFns } from "./demographicinformation.vue?vue&type=template&id=aff98c0e"
import script from "./demographicinformation.vue?vue&type=script&lang=js"
export * from "./demographicinformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports